
import "./config.coffee"

import 'lazysizes'
import 'lazysizes/plugins/print/ls.print'
import 'lazysizes/plugins/unload/ls.unload'
